import { useEffect, useState } from "react";
import { EventLayout } from "@/components/EventLayout";
import { useEvent } from "@/context/EventContext";
import { Mail, BellRing, Megaphone, Clock, Gift, MessageSquare } from "lucide-react";

const TYPE_META = {
  reminder: { label: "RSVP reminder", icon: BellRing, cls: "bg-[#D4C5B3]/30 text-[#8a744f]" },
  "auto-reminder": { label: "Auto reminder", icon: BellRing, cls: "bg-[#D4C5B3]/30 text-[#8a744f]" },
  broadcast: { label: "Guest update", icon: Megaphone, cls: "bg-[#8C9A86]/15 text-[#5f6b59]" },
  message: { label: "Custom message", icon: MessageSquare, cls: "bg-[#8C9A86]/15 text-[#5f6b59]" },
  thankyou: { label: "Thank-you note", icon: Gift, cls: "bg-[#C67A7A]/12 text-[#9c5757]" },
};

export default function Messages() {
  const { eapi } = useEvent();
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    eapi.get("/messages").then(({ data }) => setMessages(data)).catch(() => setMessages([])).finally(() => setLoading(false));
  }, [eapi]);

  return (
    <EventLayout>
      <div className="max-w-3xl mx-auto px-5 sm:px-8 py-8 lg:py-12" data-testid="messages-page">
        <p className="overline">Communication</p>
        <h1 className="font-serif text-4xl tracking-tight mb-2">Message history</h1>
        <p className="text-stone-500 mb-8 text-sm">Every reminder and update you've sent to your guests, logged with recipients and timestamps.</p>
        {loading ? <p className="text-sm text-stone-400">Loading…</p>
          : messages.length === 0 ? <div className="bg-white border border-dashed border-[#E8E6E1] rounded-lg p-12 text-center text-sm text-stone-400">No messages sent yet.</div>
          : <div className="space-y-3">
              {messages.map((m) => {
                const meta = TYPE_META[m.type] || { label: m.type, icon: Mail, cls: "bg-stone-100 text-stone-500" };
                return (
                  <div key={m.id} data-testid={`message-row-${m.id}`} className="bg-white border border-[#E8E6E1] rounded-lg p-5">
                    <div className="flex items-center justify-between gap-3 flex-wrap">
                      <span className={`inline-flex items-center gap-1.5 text-xs px-3 py-1 rounded-full ${meta.cls}`}><meta.icon size={12} /> {meta.label}</span>
                      <span className="text-xs text-stone-400 flex items-center gap-1.5"><Clock size={12} /> {formatDate(m.sent_at)}</span>
                    </div>
                    <p className="text-sm font-medium text-stone-800 mt-3">{m.subject}</p>
                    <p className="text-xs text-stone-500 mt-1">Sent to {m.count} guest{m.count === 1 ? "" : "s"}</p>
                  </div>
                );
              })}
            </div>}
      </div>
    </EventLayout>
  );
}

function formatDate(d) {
  try { return new Date(d).toLocaleString(undefined, { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" }); }
  catch { return d; }
}
